import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import ProgressSpinner from '@avtechsoftware/react-component-library/src/components/common/ProgressSpinner';
import GenericErrorFallback from '../../common/GenericErrorFallback/GenericErrorFallback';
import PublicDeviceDetailsLayout from './PublicDeviceDetailsLayout';
import envConfig from '../../../envConfig';

function PublicDeviceDetailsPage() {
  const { publicPageHash } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [deviceData, setDeviceData] = useState(null);

  useEffect(() => {
    const fetchDeviceData = async () => {
      try {
        setIsLoading(true);

        const response = await axios.get(`${envConfig.apiUrl}/api/v1/device-data/public/device-details/${publicPageHash}`);
        setDeviceData(response.data);
        setError(null);
      } catch (err) {
        setError('Unexpected error loading device');
      } finally {
        setIsLoading(false);
      }
    };

    fetchDeviceData();

    return () => {
      setDeviceData(null);
    };
  }, [publicPageHash]);

  if (isLoading) {
    return (
      <div className="row d-flex justify-content-center my-5">
        <div>
          <ProgressSpinner />
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="row d-flex justify-content-center my-5">
        <div>
          <GenericErrorFallback
            resetErrorBoundary={() => window.location.reload()}
            error={error}
          />
        </div>
      </div>
    );
  }

  return (
    <PublicDeviceDetailsLayout device={deviceData} />
  );
}

export default PublicDeviceDetailsPage;
